import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <span className="footer-copy">© 2025 Rahul Sharad Pandit</span>
        <span className="footer-built">BUILT WITH PRECISION · IRVINE, CA</span>
      </div>
    </footer>
  );
}
